var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { width: "100%", outlined: "", elevation: "0" } },
    [
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _vm.loading || _vm.exportConfig || _vm.setToMaster
            ? _c(
                "v-overlay",
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { staticClass: "ma-1 pa-1" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mb-2",
                  attrs: {
                    disabled:
                      _vm.selected.length <= 0 || !_vm.ifCanDeleteConfig(),
                    color: "red",
                  },
                  on: { click: _vm.onPressDeleteSelected },
                },
                [_vm._v(" Delete selected ")]
              ),
              _c("v-data-table", {
                ref: "table",
                staticStyle: { width: "100%" },
                attrs: {
                  "group-by": "group",
                  "fixed-header": "",
                  items: _vm.configs,
                  "item-value": (item) => item.uid,
                  headers: _vm.headers,
                  "hide-default-footer": "",
                  "disable-pagination": "",
                  "show-select": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.group",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-card-text",
                          { staticClass: "orange--text ma-0 pa-0" },
                          [_vm._v(_vm._s(item.group))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.tag",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-card-text",
                          { staticClass: "green--text ma-0 pa-0" },
                          [_vm._v(_vm._s(_vm.getTagText(item.tag)))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.owner",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-card-text",
                          { staticClass: "blue--text ma-0 pa-0" },
                          [_vm._v(_vm._s(_vm.getUserName(item)))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.created",
                    fn: function ({ item }) {
                      return [
                        _c("v-card-text", { staticClass: "ma-0 pa-0" }, [
                          _vm._v(_vm._s(_vm._f("formatDate")(item.created))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.aud",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "orange--text pa-2",
                            attrs: {
                              disabled: !_vm.ifCanEditAudience(),
                              outlined: "",
                              small: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onPressEditAudience(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                (item.aud == null ? "" : item.aud).toUpperCase()
                              ) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.application",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "pa-2",
                            attrs: {
                              disabled: !_vm.ifCanEditVersion(),
                              outlined: "",
                              color: "green",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onPressEditVersion(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.minver || "-") +
                                " - " +
                                _vm._s(item.maxver || "-") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.master",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", "max-width": "50%" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                loading:
                                                  _vm.setToMaster == item.uid,
                                                icon: "",
                                                color: item.master
                                                  ? "green"
                                                  : "grey lighten-2",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressSetMaster(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              _vm._s(
                                                item.master
                                                  ? "mdi-checkbox-marked-circle"
                                                  : "mdi-checkbox-blank-circle-outline"
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Set Master")])]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", "max-width": "50%" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                loading:
                                                  _vm.loading == item.uid,
                                                icon: "",
                                                color: "orange",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressInfo(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-information")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.info != undefined &&
                                    item.info.length != 0
                                    ? item.info
                                    : "no info"
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanExportConfig(),
                                                loading:
                                                  _vm.exportConfig == item.uid,
                                                icon: "",
                                                color: "teal lighten-1",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressExport(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "20" } },
                                            [_vm._v("mdi-content-copy")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Export to my configs")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                loading:
                                                  _vm.loading == item.uid,
                                                icon: "",
                                                color: "red",
                                                disabled:
                                                  !_vm.ifCanDeleteConfig() ||
                                                  item.master,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressDelete(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-delete")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Delete from storage")])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                disabled:
                                                  !_vm.ifCanDeployConfig(),
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPressAddToDeploy(
                                                    item.name
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "22" } },
                                            [_vm._v("mdi-folder-plus")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Add to deploy")])]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }